<template>
  <div id="product-add-by-amazon">
    <button-scroll-to-top></button-scroll-to-top>
    <banner v-if="banner" :bannerContent="banner" />
    <no-multi-channel-service v-if="noEvidenceImage" />
    <div v-if="!noEvidenceImage">
      <div>
        <div class="box-search-keyword-get-lastest" style="justify-content: space-between;">
          <div class="flexbox gap-10">
            <get-latest-products-button
              :key="`products-add-by-amazon`"
              getFrom="add-by-amazon"
              @handleGetLatestProducts="handleGetLatestProducts()"
            />
            <div class="box-search-keyword">
              <div class="item">
                <div class="item-addon">
                  <input type="text" v-model.trim="keyword" class="form-control input-search-keyword" placeholder="ASIN、SKU、FNSKU、商品名" @keydown.enter="onHandleSearch">
                  <span class="clear-keyword-search" @click.prevent="resetFilters()"><i class="fa fa-times"></i></span>
                </div>
              </div>
              <div class="item"><button type="button" class="btn btn-primary btn-search" @click="onHandleSearch()">検索</button></div>
            </div>
            <div
              class="promotion-filter"
              :class="{ disabled: isBasicPlan }"
            >
              <img
                src="https://image-yoshino.sakura.ne.jp/monster/SaleMonAgent.png"
                alt="SaleMon Agent"
                class="promotion-logo"
              />

              <toggle-button
                v-model="isShowPromotionProduct"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
                :height="26"
                :width="60"
                :sync="true"
                :disabled="isBasicPlan"
                @change="onHandleSearch"
              />

              <span v-if="!isBasicPlan " class="promotion-label" :class="{ 'promotion-label--active': isShowPromotionProduct }">
                {{ isShowPromotionProduct ? '出品推奨商品のみ表示中' : '出品推奨商品のみ表示する' }}
              </span>
              <span v-else class="premium-label">
                <i class="fa fa-lock text-warning" aria-hidden="true"></i> プレミアム限定機能
              </span>

              <i
                v-if="!isBasicPlan"
                class="fa fa-info-circle promotion-info"
                v-tooltip="{
                  content: `セルモンエージェントで出品を推奨している<br> 商品のみを表示します。`,
                  html: true,
                  classes: ['promotion-tooltip']
                }"
              />
              <div v-if="!isBasicPlan" class="promotion-info-mobile">
                セルモンエージェントで出品を推奨している <br>
                商品のみを表示します。
              </div>
              <div
                v-else
                class="require-premium-tooltip"
              >
                <div>
                  セルモンエージェントで出品を推奨している<br>
                  商品のみを表示します。
                </div>

                <a
                  class="upgrade-link"
                  @click.stop="$router.push({name: 'Setting', params: {tab: 'plan-info'}})"
                >
                  プレミアムプランにアップグレードする
                </a>
              </div>
            </div>
          </div>
          <div class="box-plan-info">
            <div v-if="!isEmptyObj(currentPlan)">
              残り出品可能数：<span>{{ remainingProduct }}</span>件
            </div>
            <button class="btn btn-primary btn-additional-of-list" @click="getAllPlans">出品数追加</button>
          </div>
        </div>

        <div class="products-add-by-amazon-table">
          <add-by-amazon-table
            :url="'Product/available'"
            :extraUrl="['Product/get-image-name', 'Product/get-identifiers']"
            :extraUrlMode="true"
            :columns="columns"
            :keyword="keyword"
            :isShowPromotionProduct="isShowPromotionProduct"
            :needExtraData="true"
            :loadingTableMode="true"
            :isHideNoItem="isHideNoItem"
            :checkedItems="checkedItems"
            :isBasicPlan="isBasicPlan"
            :paginationStorageKey="'productAdd'"
            ref="productAddTable"
            @extraData="extraData = $event"
            @countData="countData = $event"
            @checkBoxAll="checkBoxAll"
            @addProducts="addProducts"
            @addProductsAndPurchase="addProductsAndPurchase"
          >
            <template slot="deleteCheckBox" slot-scope="props">
              <div>
                <input type="checkbox" :value="props.rowData.asin" v-model="checkedItems" @change="refreshCheckAll">
              </div>
            </template>
            <template slot="productName" slot-scope="props">
              <div class="flexbox justify-between flex-nowrap flex-content-start gap-10">
                <div>
                  <div class="flexbox flex-nowrap gap-10">
                    <loading-block class="product-image" :value="props.rowData.image" type="image">
                      <img :src="props.rowData.image" alt="" class="product-img group-table__product_img product-image">
                    </loading-block>
                    <div class="">
                      <div class="tooltip-wrapper">
                        <loading-block :value="props.rowData.productName" type="string" :class="{ 'group-table__product_name': props.isGroupTable, 'product-name': true }">
                          <a
                            :href="'https://www.amazon.co.jp/gp/offer-listing/' + props.rowData.asin"
                            target="_blank"
                            class="text--underline product-name"
                            >
                            {{ sliceProductName(props.rowData.productName) }}
                          </a>
                          <span class="tooltip-text">{{ props.rowData.productName }}</span>
                        </loading-block>
                      </div>
                      <div class="flexbox">
                        <div class="flexbox gap-5 mr-r-10">
                          <span>
                            <b>ASIN：</b>
                            {{ props.rowData.asin }}
                          </span> /
                          <span>
                            <b>SKU：</b>
                            {{ props.rowData.sku }}
                          </span> /
                          <span>
                            <b>FNSKU：</b>
                            {{ props.rowData.fnsku }}
                          </span>
                        </div>
                        <div v-if="props.rowData.skus && Object.keys(props.rowData.skus).length > 1" :class="props.rowData.asin === props.data[props.data.length - 1].asin ? 'dropup' : 'dropdown'">
                          <a class="text--underline" @click.stop>
                          その他 {{ Object.keys(props.rowData.skus).length - 1 }} 件
                          </a>
                          <ul class="dropdown-menu">
                            <li
                              v-for="([fnsku, sku], index) in Object.entries(props.rowData.skus).filter(([key]) => key !== props.rowData.fnsku)"
                              :key="index"
                            >
                              <div><b>SKU：</b>{{ sku }}</div>
                              <div><b>FNSKU：</b>{{ fnsku }}</div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="flexbox flex-content-center">
                        <loading-block :value="props.rowData.amazonPrice" type="money" style="flex-grow: 2;">
                          <span class="">Amazon価格：¥</span><span class="text-price-number">{{formatAmount(props.rowData.amazonPrice)}}</span>
                        </loading-block>
                      </div>
                    </div>
                  </div>
                  <div v-if="props.rowData.mark && props.rowData.mark !== 'NULL'" class="alert alert-warning mark-warning product-mark-warning" role="alert">
                    <i class="text-warning fa fa-exclamation-triangle text-size-20 warning-icon mark-warning" aria-hidden="true"></i>
                    <span class="mark-warning" v-html="replaceHTMLSellerInfo(props.rowData.mark)"></span>
                  </div>
                </div>
                <div class="flex justify-right flex-nowrap gap-10">
                  <div v-if="props.rowData.hasScOffer" class="box-warehouse box-warehouse-sc">
                    <div class="flex gap-10">
                      <warehouse-icon
                        :key="`sc-icon-${props.rowData.asin}}`"
                        :iconImage="icons.salmonSc"
                        :warehouseName="`STOCKCREW倉庫`"
                        :iconClassName="`sc-icon`"
                        :imageClassName="`sc-image`"
                        style="width: 30%;"
                      />
                      <div class="flexbox justify-right">
                        <div class="flexbox flex-nowrap gap-5">
                          <span class="w-80 text-right">受取金額</span>
                          <span>¥</span>
                          <product-input-money
                            :key="'products-sc-offerPrice-' + props.rowData.asin"
                            :ref="'products-sc-offerPrice-' + props.rowData.asin"
                            :value="props.rowData.scOfferPrice"
                            validation="required|moneyMin:1|numberLength:6"
                            :product="props.rowData"
                            :warehouseType="`sc`"
                            :class="{ 'alert-warning-text': comparePrice(props.rowData.scOfferPrice, props.rowData.amazonPrice) }"
                            :customStyle="{color: '#800000', 'font-size': '20px'}"
                            @input="scCheckBulkUpdate"
                            class="product-input-money"
                          />
                        </div>
                        <div class="flexbox flex-nowrap gap-5">
                          <span class="w-80 text-right">予想出品金額</span>
                          <span>¥</span>
                          <span class="w-100 expected-amount">{{scExpectedAmount(props.rowData.scOfferPrice)}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="flexbox w-rate-100">
                      <div class="flex gap-10 pd-t-10">
                        <span class="text-gray">保管サイズ</span>
                        <span v-if="props.rowData.scStorageSize">
                          {{ props.rowData.scStorageSize}}
                        </span>
                        <span v-else>-</span>
                      </div>
                      <div class="flexbox justify-between flex-content-baseline w-rate-100">
                        <div class="flex gap-20">
                          <span class="text-gray">送料見積</span>
                          <span>{{ props.rowData.scShippingFee ? '¥' + formatQuantity(props.rowData.scShippingFee) : '-' }}</span>
                        </div>
                        <div>
                          <span class="text-right">
                            <span class="text-size-28 text-primary font-bold" style="line-height: 28px;">{{ formatQuantity(props.rowData.scInventoryQuantity) }}</span>
                            個
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box-warehouse">
                    <div class="flex gap-10">
                      <warehouse-icon
                        :key="`amazon-icon-${props.rowData.asin}}`"
                        :iconImage="icons.Amazon"
                        :warehouseName="`Amazon倉庫`"
                        :iconClassName="`amazon-icon`"
                        :imageClassName="`amazon-image`"
                        style="width: 30%;"
                      />
                      <div class="flexbox justify-right">
                        <div class="flexbox flex-nowrap gap-5">
                          <span class="w-80 text-right">受取金額</span>
                          <span>¥</span>
                          <product-input-money
                            :key="'products-amazon-offerPrice-' + props.rowData.asin"
                            :ref="'products-amazon-offerPrice-' + props.rowData.asin"
                            :value="props.rowData.offerPrice"
                            validation="required|moneyMin:1|numberLength:6"
                            :product="props.rowData"
                            :class="{ 'alert-warning-text': comparePrice(props.rowData.offerPrice, props.rowData.amazonPrice) }"
                            :customStyle="{color: '#800000', 'font-size': '20px'}"
                            @input="checkBulkUpdate"
                            class="product-input-money"
                            style="width: 100px;"
                          />
                        </div>
                        <div class="flexbox flex-nowrap gap-5">
                          <span class="w-80 text-right">予想出品金額</span>
                          <span>¥</span>
                          <span class="w-100 expected-amount">{{expectedAmount(props.rowData.offerPrice)}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="flexbox justify-between flex-content-baseline mr-t-15 w-rate-100" style="align-content: end;">
                      <div class="w-rate-100"></div>
                      <div class="flex gap-20">
                        <span class="text-gray">送料見積</span>
                        <shipping-fee :key="props.rowData.asin" :rowData="props.rowData" :customStyle="{'font-size': '12px'}" checkFrom="list" />
                      </div>
                      <div>
                        <span class="text-right">
                          <span class="text-size-28 text-primary font-bold" style="line-height: 28px;">{{ formatQuantity(props.rowData.numberOfStock) }}</span>
                          個
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template slot="action" slot-scope="props">
              <button type="button" class="btn btn-warning btn-action-row" @click.prevent="addProduct(props.rowData)">追加</button>
              <button
                v-if="isBasicPlan && (!props.rowData.hasOffer || (!props.rowData.speedJudgmentDate && props.rowData.judgmentStatusCode !== '2'))"
                type="button"
                class="btn btn-warning btn-purchase-row btn-action-row"
                @click.prevent="addProductAndPurchase(props.rowData)"
              ><i class="fa fa-rocket" aria-hidden="true"></i> スピード審査で追加</button>
            </template>
          </add-by-amazon-table>
        </div>
      </div>
    </div>
    <modal-add-listings
      v-if="openModalAddListings"
      :maxListingAmount="maxListingAmount"
      :remainingProduct="remainingProduct"
      :neededProductCount="neededProductCount"
      :listPlans="suggestPlans"
      :pending-asins="checkedItems"
      @updatePlanStatus="updatePlanStatus"
      @close="handleCloseOverProductsModal"
    />
    <add-by-amazon-purchase-modal
      v-if="openPurchaseModal"
      :items="purchaseModalItems"
      :price="speedJudgmentPrice"
      :loading="purchaseModalLoading"
      @close="openPurchaseModal = false"
      @purchase="handlePurchaseModalPurchase"
    />
  </div>
</template>

<script>
import InputMoney from '@/components/AmazonInputMoney'
import AddByAmazonTable from '@/components/AddByAmazonTable'
import LoadingBlock from '@/components/LoadingBlock'
import ShippingFee from '@/components/ShippingFee'
import GetLatestProductsButton from '@/components/GetLatestProductsButton'
import ProductService from '@/services/productservice'
import SettingService from '@/services/settingservice'
import PlanService from '@/services/planservice'
import Util, { replaceHTMLSellerInfo } from '@/common/utility'
import { RomajiCheck } from '@/validation/custom-rules'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import ButtonScrollToTop from '@/components/ButtonScrollToTop'
import NoMultiChannelService from '@/components/NoMultiChannelService'
import { mapGetters } from 'vuex'
import ProductInputMoney from '@/view/productsNew/ProductInputMoney'
import ModalAddListings from '@/components/ModalAddListings'
import WarehouseIcon from '@/view/productsNew/WarehouseIcon'
import Banner from './Banner'
import AddByAmazonPurchaseModal from '@/view/productsNew/AddByAmazonPurchaseModal'

export default {
  props: {
    hasRefreshAmazonTable: {
      type: Boolean,
      default: false
    },
    currentTab: {
      type: String,
      default: ''
    },
    banner: {
      type: String,
      default: ''
    }
  },
  components: {
    InputMoney,
    LoadingBlock,
    ShippingFee,
    GetLatestProductsButton,
    ButtonScrollToTop,
    AddByAmazonTable,
    NoMultiChannelService,
    ProductInputMoney,
    WarehouseIcon,
    Banner,
    ModalAddListings,
    AddByAmazonPurchaseModal
  },
  data () {
    return {
      error: null,
      loader: null,
      countData: null,
      extraData: null,
      resetValidator: false,
      columns: [
        {
          title: '',
          name: 'deleteCheckBox',
          label: '<input type="checkbox" id="amz-delete-checkbox-all">',
          field: 'deleteCheckBox',
          customCell: true,
          cellClass: 'text-center align-middle',
          headerClass: 'w-30',
          sortable: false,
          checkable: true,
          thClass: 'grouped-table-header',
          tdClass: 'align-middle',
          width: '30px'
        },
        {
          title: '商品情報',
          sortable: false,
          name: 'productName',
          label: '<div class="flexbox justify-between"><span>商品情報</span><span>倉庫毎の情報 ※各金額は税込金額とする</span></div>',
          field: 'productName',
          customCell: true,
          cellClass: 'text-left product-list-name',
          headerClass: 'grouped-table-header',
          thClass: 'grouped-table-header product-name',
          minWidth: '552px'
        },
        {
          title: '更新',
          name: 'action',
          label: '',
          field: 'action',
          customCell: true,
          cellClass: 'text-center update-button',
          headerClass: 'w-80',
          sortable: false,
          thClass: 'grouped-table-header',
          tdClass: 'text-center',
          width: '80px'
        }
      ],
      openModalAddListings: false,
      keyword: '',
      checkAll: false,
      checkedItems: [],
      currentPlan: {},
      suggestPlans: [],
      maxListingAmount: 0,
      neededProductCount: 0,
      remainingProduct: 0,
      isShowPromotionProduct: false,
      showTooltip: false,
      openPurchaseModal: false,
      purchaseModalItems: [],
      purchaseModalLoading: false,
      pendingPurchaseParams: null,
      speedJudgmentPrice: null
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUser',
      icons: 'getWareHouseIcons'
    }),
    noEvidenceImage () {
      return ['0', '9'].includes(this.userInfo.multiChannelSenderFlg)
    },
    isHideNoItem () {
      return !this.keyword
    },
    isBasicPlan () {
      return this.userInfo.memberPlan === '0'
    }
  },
  created () {
    this.getPlanStatus()
    ProductService.getSpeedJudgmentPrice()
      .then(data => {
        this.speedJudgmentPrice = data.pricePerItem !== undefined ? data.pricePerItem : null
      })
      .catch(() => {})
    this._restoreCheckedItemsAfterQuotaPayment()
  },
  watch: {
    $route (routeValue) {
      // Skip if not active tab — prevents double API reload when switching tabs.
      if (routeValue.params.tab !== 'add-by-amazon') return
      if (!this.noEvidenceImage) {
        this.$refs.productAddTable.resetHeaderTabAddByAmazon()
        if (this.hasRefreshAmazonTable) {
          this.resetFilters()
          // Debounce to prevent duplicate reload on rapid route changes.
          clearTimeout(this._reloadTimer)
          this._reloadTimer = setTimeout(() => {
            this.$refs.productAddTable.reload()
            this.getPlanStatus()
            this.$emit('handleNotRefreshAmazonTable', false)
          }, 500)
        }
      }
    }
  },
  mounted () {
    this.$events.listen('done', (url) => {
      (url === 'Product/available') && this.loader && this.loader.hide()
    })
    this.$events.listen('apiSuccess', (url) => {
      if (url === 'Product/available' && this.resetValidator) {
        this.$validator.reset()
        this.resetValidator = false
      }
    })
    if (this.currentTab && this.currentTab === 'add-by-amazon') {
      let logParams = {
        name: eventCode.manage_products.add_by_amazon_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  },
  methods: {
    replaceHTMLSellerInfo,
    // Amazonの価格より50％以上高い時, 50％以上安い時警告
    comparePrice (offerPrice, amazonPrice) {
      var checkResult = false
      var inputPrice = Number.parseInt(offerPrice)
      var basePrice = Number.parseInt(amazonPrice)
      if (this.isNumber(inputPrice) && this.isNumber(basePrice) && basePrice > 0) {
        const halfPrice = basePrice * 0.5
        if (inputPrice <= halfPrice) {
          checkResult = true
        }
        const oneHalfPrice = basePrice * 1.5
        if (inputPrice >= oneHalfPrice) {
          checkResult = true
        }
        if ((inputPrice > halfPrice) && (inputPrice < oneHalfPrice)) {
          checkResult = false
        }
      }
      return checkResult
    },
    isNumber (numVal) {
      // チェック条件パターン
      var pattern = /^[-]?([1-9]\d*|0)(\.\d+)?$/
      // 数値チェック
      return pattern.test(numVal)
    },
    /*
     * Return img source from DB or noimg url
     *
     * @param {String} value Img src
     *
     * @return {String}
     */
    prepareImgSrc (value) {
      return value || `${process.env.NODE_DOMAIN}/static/dists/img/noimg.png`
    },
    /*
     * Call API to add product
     *
     * @param {Object} item Row's data
     *
     * @return void
     */
    validateItemOfferPrice (item) {
      let offerPrice = parseInt(item.offerPrice)
      if (!offerPrice || (offerPrice === 0) || (offerPrice.toString().length > 6)) {
        return false
      }

      if (item.hasScOffer) {
        let scOfferPrice = parseInt(item.scOfferPrice)
        if (!scOfferPrice || (scOfferPrice === 0) || (scOfferPrice.toString().length > 6)) {
          return false
        }
      }

      return true
    },
    async getAllPlans () {
      this.loader = this.$loading.show()
      await PlanService.getAllPlans()
        .then(data => {
          this.suggestPlans = data.salmonPlan.avaiablePlans
          this.neededProductCount = 0
          this.openModalAddListings = true
        })
        .catch(err => {
          self.error = err
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    async addProduct (item) {
      EventService.postTrackLog({
        name: eventCode.manage_products.add_by_amazon_tab.click_add_button,
        properties: { asin: item.asin }
      })

      const params = {
        record: [{
          asin: item.asin,
          sku: item.sku,
          offerPrice: item.offerPrice,
          scOfferPrice: item.scOfferPrice,
          ean: item.ean && item.ean.toString().length > 0 ? item.ean : null
        }]
      }

      await this._submitAddProducts(params)
    },

    async addProducts () {
      if (!this.checkedItems.length) return false

      let params = { record: [] }
      let validItems = []

      this.checkedItems.forEach((checkedItemAsin) => {
        let product = this.$refs.productAddTable.pageData.find(item => item.asin === checkedItemAsin)
        if (product && this.validateItemOfferPrice(product) && (!product.ean || (product.ean.toString().length <= 50 && RomajiCheck.validate(product.ean)))) {
          params.record.push({
            asin: checkedItemAsin,
            sku: product.sku,
            offerPrice: product.offerPrice,
            scOfferPrice: product.scOfferPrice,
            ean: product.ean && product.ean.toString().length > 0 ? product.ean : null
          })
          validItems.push(product)
        }
      })

      if (!params.record.length) return false

      EventService.postTrackLog({
        name: eventCode.manage_products.add_by_amazon_tab.click_add_all_button,
        properties: { asins: params.record.map(item => item.asin) }
      })

      await this._submitAddProducts(params)
    },
    async createParentProducts (params) {
      this.loader = this.$loading.show()
      await ProductService.createParentProducts(params)
        .then(response => {
          this.loader && this.loader.hide()
          this.$emit('handleRefreshGroupTable', true)
        })
        .catch(err => {
          this.loader && this.loader.hide()
          this.error = err
        })
    },
    formatAmount (value) {
      return (value === null || typeof value === 'undefined' || value === 0) ? '-' : `${Util.formatMoney(value)}`
    },
    formatQuantity (value) {
      return (value === null || typeof value === 'undefined' || value === 0) ? '-' : `${Util.formatMoney(value)}`
    },
    expectedAmount (offerPrice) {
      const coefficient = this.extraData && this.extraData.coefficient ? this.extraData.coefficient : 1.3
      const tmpOfferPrice = Math.round(offerPrice)
      if (offerPrice !== null && offerPrice > 0 && tmpOfferPrice.toString().length <= 6) {
        return this.formatAmount(offerPrice * coefficient)
      }
      return ' -'
    },
    scExpectedAmount (offerPrice) {
      const coefficient = this.extraData && this.extraData.coefficient ? this.extraData.coefficient : 1.3
      const tmpOfferPrice = Math.round(offerPrice)
      if (offerPrice !== null && offerPrice > 0 && tmpOfferPrice.toString().length <= 6) {
        return this.formatAmount(offerPrice * coefficient)
      }
      return ' -'
    },
    /*
     * Custom sort for expected amount column
     *
     * @param {Array} data Table data
     * @param {String} order Order direction
     *
     * @return {String}
     */
    sortExpectedAmount (data, order) {
      if (!order) {
        return [...data]
      } else if (order === 'desc') {
        return [...data].sort((before, after) => before.offerPrice - after.offerPrice)
      }
      return [...data].sort((before, after) => after.offerPrice - before.offerPrice)
    },
    onHandleSearch () {
      this.checkAll = false
      this.checkedItems = []
      this.$refs.productAddTable.handleFilter()

      let logParams = {
        name: eventCode.manage_products.add_by_amazon_tab.click_search_button,
        properties: {
          keyword: this.keyword
        }
      }
      EventService.postTrackLog(logParams)
    },
    handleGetLatestProducts () {
      this.loader = this.$loading.show()
      this.resetFilters()
      setTimeout(() => {
        this.getLatestProducts()
      }, 500)
    },
    async getLatestProducts () {
      await ProductService.getLatestProducts()
        .then((response) => {
          this.resetValidator = true
          this.$refs.productAddTable.reload()
          this.$emit('handleRefreshGroupTable', true)
          this.getSellerInfo()
        })
        .catch((err) => {
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    async getSellerInfo () {
      await SettingService.getSellerInformation()
        .then(response => {
          this.$store.commit('setUser', response.seller)
        })
        .catch(err => {
          this.error = err
        })
    },
    async getPlanStatus () {
      let self = this
      let response = await PlanService.getPlanStatus()
      self.currentPlan = response.salmonPlan.currentPlan
      self.maxListingAmount = response.salmonPlan.maxListingAmount
      self.remainingProduct = response.salmonPlan.remainingProduct
      if (this.noEvidenceImage) {
        this.$events.fire('done', 'Product/available')
      }
    },
    async updatePlanStatus () {
      await PlanService.getPlanStatus()
        .then((response) => {
          this.currentPlan = response.salmonPlan.currentPlan
          this.maxListingAmount = response.salmonPlan.maxListingAmount
          this.remainingProduct = response.salmonPlan.remainingProduct
          this.$store.commit('toggleModal', {
            show: true,
            message: 'お支払いありがとうございます。<br/>商品数が追加されました。<br/>最大商品登録可能数が更新されました。'
          })
        })
        .catch((err) => {
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    isEmptyObj (obj) {
      return Util.isEmptyObj(obj)
    },
    refreshCheckAll () {
      const items = this.$refs.productAddTable.defaultData
      if (this.checkedItems.length === items.length) {
        this.checkAll = true
      } else {
        this.checkAll = false
      }
    },
    checkBoxAll (value) {
      const items = this.$refs.productAddTable.defaultData
      this.checkAll = value
      this.checkedItems = []
      var _self = this
      if (this.checkAll) {
        items.forEach(function (item) {
          _self.checkedItems.push(item.asin)
        })
      }
    },
    handleCloseOverProductsModal () {
      $('#over-products-modal').modal('hide')
      this.openModalAddListings = false
    },
    _restoreCheckedItemsAfterQuotaPayment () {
      const saved = sessionStorage.getItem('pendingSpeedReviewAsins')
      if (!saved) return
      try {
        const asins = JSON.parse(saved)
        if (Array.isArray(asins) && asins.length > 0) {
          this.checkedItems = asins
        }
      } catch (e) {
        // sessionStorage data corrupt — ignore
      } finally {
        sessionStorage.removeItem('pendingSpeedReviewAsins')
      }
    },
    resetFilters () {
      this.keyword = ''
    },
    checkBulkUpdate (data) {
      if (!this.$refs.productAddTable) return

      const targetItems = this.$refs.productAddTable.pageData
      let product = data.product
      let price = data.price

      targetItems.forEach(item => {
        if (item.asin === product.asin) {
          item.offerPrice = price
        }
      })
    },
    scCheckBulkUpdate (data) {
      if (!this.$refs.productAddTable) return

      const targetItems = this.$refs.productAddTable.pageData
      let product = data.product
      let price = data.price

      targetItems.forEach(item => {
        if (item.asin === product.asin) {
          item.scOfferPrice = price
        }
      })
    },
    async addProductAndPurchase (item) {
      const params = {
        record: [{
          asin: item.asin,
          sku: item.sku,
          offerPrice: item.offerPrice,
          scOfferPrice: item.scOfferPrice,
          ean: item.ean && item.ean.toString().length > 0 ? item.ean : null
        }]
      }
      this.pendingPurchaseParams = params
      this.purchaseModalItems = [item]
      this.openPurchaseModal = true
    },
    async addProductsAndPurchase () {
      if (!this.checkedItems.length) return false

      let params = { record: [] }
      let validItems = []

      this.checkedItems.forEach((checkedItemAsin) => {
        let product = this.$refs.productAddTable.pageData.find(item => item.asin === checkedItemAsin)
        if (product && this.validateItemOfferPrice(product) && (!product.ean || (product.ean.toString().length <= 50 && RomajiCheck.validate(product.ean)))) {
          params.record.push({
            asin: checkedItemAsin,
            sku: product.sku,
            offerPrice: product.offerPrice,
            scOfferPrice: product.scOfferPrice,
            ean: product.ean && product.ean.toString().length > 0 ? product.ean : null
          })
          validItems.push(product)
        }
      })

      if (!params.record.length) return false

      if (!this.isBasicPlan) return false
      const eligibleItems = validItems.filter(product =>
        !product.hasOffer || (!product.speedJudgmentDate && product.judgmentStatusCode !== '2')
      )
      if (!eligibleItems.length) return false

      this.pendingPurchaseParams = { record: eligibleItems.map(p => params.record.find(r => r.asin === p.asin)).filter(Boolean) }
      this.purchaseModalItems = eligibleItems
      this.openPurchaseModal = true
    },
    async handlePurchaseModalPurchase (localItems) {
      this.purchaseModalLoading = true
      try {
        await this._addAndPurchase(localItems)
      } finally {
        this.purchaseModalLoading = false
        this.openPurchaseModal = false
      }
    },
    async _addAndPurchase (localItems) {
      try {
        const params = this._buildParamsFromItems(localItems)
        if (params) await this._submitAddProducts(params)

        if (this.openModalAddListings) return

        const asins = localItems.map(i => i.asin)
        try {
          const res = await ProductService.purchasePriorityReview({ asins, redirectPath: 'products-new/add-by-amazon' })
          if (res && res.records && res.records.data && res.records.data.checkoutUrl) {
            window.location.href = res.records.data.checkoutUrl
          }
        } catch (_err) {
          this.$store.commit('toggleModal', {
            show: true,
            message: 'スピード審査の決済に失敗しました。<br/>商品の追加は正常に完了しています。<br/>スピード審査をご希望の場合は、商品一覧から再度お申し込みください。'
          })
        }
      } catch (err) {
        this.$store.commit('toggleModal', { show: true, message: err })
      }
    },
    _buildParamsFromItems (items) {
      if (!items || !items.length) return null
      return {
        record: items.map(item => ({
          asin: item.asin,
          sku: item.sku,
          offerPrice: item.offerPrice,
          scOfferPrice: item.scOfferPrice,
          ean: item.ean && item.ean.toString().length > 0 ? item.ean : null
        }))
      }
    },
    async _submitAddProducts (params) {
      this.loader = this.$loading.show()
      await ProductService.addProducts(params)
        .then(response => {
          this.loader && this.loader.hide()
          if (response.data && response.data.suggestPlans && response.data.suggestPlans.length > 0) {
            this.openModalAddListings = true
            this.suggestPlans = response.data.suggestPlans
            this.maxListingAmount = response.data.maxListingAmount
            this.remainingProduct = response.data.remainingProduct
            this.neededProductCount = response.data.neededProductCount
            return
          }
          const addedAsins = params.record.map(r => r.asin)
          if (addedAsins.length === 1) {
            const item = this.$refs.productAddTable.pageData.find(i => i.asin === addedAsins[0])
            this.$refs.productAddTable.handleData(item || { asin: addedAsins[0] }, 'delete')
          } else {
            this.$refs.productAddTable.handleData(addedAsins, 'deleteAll')
          }
          this.checkedItems = this.checkedItems.filter(a => !addedAsins.includes(a))
          if (addedAsins.length > 1) {
            this.checkAll = false
          }
          this.getPlanStatus()
          this.createParentProducts({ asin: addedAsins })
        })
        .catch(error => {
          this.loader && this.loader.hide()
          this.$store.commit('toggleModal', { show: true, message: error })
          this.err = error
        })
    },
    sliceProductName (productName) {
      if (!productName) {
        return ''
      }
      const length = 80
      if (productName.length <= length) return productName

      return productName.slice(0, length / 2) + ' ... ' + productName.slice(-(length / 2))
    }
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
  }
}
</script>

<style scoped>
#product-add-by-amazon /deep/ .table > tbody > tr > td {
  vertical-align: top;
  padding-top: 8px;
}
.btn-action-row {
  display: block;
  width: 100%;
  white-space: normal;
  line-height: 1.3;
  font-size: 12px;
  text-align: center;
}
.btn-purchase-row {
  margin-top: 6px;
  white-space: nowrap;
  padding-left: 4px;
  padding-right: 4px;
  color: #fff;
  font-weight: 700;
  border: none;
  background: linear-gradient(135deg, #f77b00 0%, #f9a825 100%);
  box-shadow: 0 2px 6px rgba(230, 100, 0, 0.3);
  transition: filter 0.15s, transform 0.1s;
}
.btn-purchase-row:hover,
.btn-purchase-row:focus {
  color: #fff;
  filter: brightness(1.08);
  transform: translateY(-1px);
}
.box-add-amz-product-checked-all {
  text-align: center;
  margin-top: 30px;
}
.box-add-amz-product-checked-all .btn-add-amz-product-checked-all {
  border-radius: 5px;
}
.box-warehouse {
  width: 280px;
  display: flex;
  align-items: center;
  align-content: center;
  flex-direction: column;
  justify-content: space-between;
  min-height: 130px;
  max-height: 150px;
  padding: 5px;
  border: 1px solid #ff9900;
  border-radius: 8px;
  background-image: linear-gradient(0deg, #eff1f2 50%, #fff 50%);
  font-size: 12px;
}
.box-warehouse-sc {
  border: 1px solid #00b7bd;
}
.product-input-money {
  width: 100px;
  height: 35px;
  color: #800000;
  font-weight: bold;
}
.text-price {
  color: #B12704;
}
.text-price-number {
  font-size: 20px;
  font-weight: bold;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.expected-amount {
  text-align: right;
  padding: 3px 15px;
}
.text-primary {
  color: #2e75b6;
}
.text-gray {
  color: #808080;
}
.dropdown .dropdown-menu, .dropup .dropdown-menu {
  display: none;
  position: absolute;
  list-style: circle;
  top: 0;
  left: 120%;
  background: #595959;
  min-width: 250px;
  z-index: 1000;
  padding: 10px 30px;
  margin: unset;
  color: #fff;
  border-radius: unset;
}
.dropup .dropdown-menu {
  top: unset;
  bottom: 0;
  left: 120%;
}
.dropdown:hover .dropdown-menu, .dropup:hover .dropdown-menu {
  display: block;
}
.dropdown-menu li {
  border-bottom: 1px dotted #fff;
  margin-bottom: 10px;
}
.tooltip-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.tooltip-text {
  visibility: hidden;
  background-color: #555;
  color: #fff;
  text-align: left;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  position: absolute;
  z-index: 1;
  top: 110%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  width: 70%;
}
.tooltip-text::after {
  content: '';
  position: absolute;
  top: -10px;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #555 transparent;
}
.tooltip-wrapper:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
label.vue-js-switch {
  margin-bottom: unset;
}
.promotion-filter {
  display: flex;
  align-items: center;
  gap: 10px;

  min-width: 330px;

  position: relative;
}

.promotion-filter.disabled {
  background: #f7f7f7;
}

.promotion-logo {
  height: 32px;
  width: auto;
}

.promotion-label {
  font-weight: 700;
  font-size: 18px;
}
.promotion-label--active {
  color: #00b050;
}

.premium-label {
  font-size: 14px;
  color: #a58c45;
  font-weight: 600;
}

.promotion-info {
  color: #2e75b6;
  cursor: pointer;
  margin-left: auto;
}

.promotion-filter.disabled .vue-js-switch {
  opacity: 0.5;
}

.require-premium-tooltip {
  position: absolute;
  top: 100%;
  left: 20px;

  display: none;

  padding: 10px;

  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0,0,0,.15);

  z-index: 9999;
}
.promotion-filter.disabled:hover .require-premium-tooltip {
  display: block;
}

.promotion-info-mobile {
  display: none;
}

.upgrade-link {
  display: inline-block;
  margin-top: 8px;
  color: #2e75b6;
  text-decoration: underline;
  cursor: pointer;
}
.box-plan-info {
  display: flex;
  align-items: center;
  justify-content: end;
  flex-wrap: wrap;
  gap: 10px;
}
@media (max-width: 1300px) {
  .box-search-keyword-get-lastest {
    display: block;
  }
  .box-plan-info {
    margin-top: 10px;
    justify-content: end;
  }
}
@media (max-width: 768px) {
  #product-add-by-amazon {
    padding: 15px;
  }
  .promotion-filter {
    flex-wrap: wrap;
    min-width: unset;
  }
  .promotion-info {
    display: none;
  }
  .promotion-info-mobile {
    display: block;
    width: 100%;
    font-size: 12px;
    color: #555;
    margin-top: 2px;
  }
  .promotion-filter.disabled:hover .require-premium-tooltip {
    display: none;
  }
  .promotion-filter.disabled .require-premium-tooltip {
    display: block;
    position: static;
    box-shadow: none;
    border: none;
    background: transparent;
    padding: 2px 0 0 0;
    font-size: 12px;
    color: #555;
    width: 100%;
  }
}
@media (max-width: 576px) {
  #product-add-by-amazon {
    padding: 10px 5px;
  }
  .box-plan-info {
    margin-top: 0px;
  }
  .box-search-keyword .input-search-keyword {
    width: 270px;
  }
}
</style>
<style>
.promotion-tooltip {
  background: #222;
  color: #fff;
  border-radius: 4px;
  padding: 5px;
  box-shadow: 0 4px 12px rgba(0,0,0,.25);
}

.promotion-tooltip a {
  color: #4da3ff;
  text-decoration: underline;
}

.promotion-tooltip .tooltip-inner {
  background: #222;
  color: #fff;
  padding: 10px 12px;
  max-width: 360px;
  text-align: left;
}

.promotion-tooltip .tooltip-arrow {
  border-color: #222;
}
</style>



// WEBPACK FOOTER //
// src/view/productsNew/ProductNewAdd.vue